import { css, cx } from '@linaria/atomic';
import { theme } from '@frontend/theme';
import { transparentize } from '../../../../helpers/color/transparentize';
import type { RadioOptionProps } from './types';

type RadioStyleProps = Pick<RadioOptionProps, 'active' | 'checked' | 'disabled'>;

const radioBase = css`
  min-width: 20px;
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  &::before {
    width: 28px;
    height: 28px;
    content: '';
    display: block;
    background: ${theme.colors.neutral30};
    border-radius: 50%;
    pointer-events: none;
    position: absolute;
    top: 0;
    left: 0;
    margin-top: -4px;
    margin-left: -4px;
    transform: scale(0);
    transform-origin: 50% 50%;
    transition: transform 200ms ease-out;
  }

  &::after {
    content: '';
    width: 100%;
    height: 100%;
    background: white;
    border: 1px solid ${theme.colors.neutral40};
    border-radius: 50%;
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    transition: background 200ms ease-out, border-color 200ms ease-out;
  }
`;

const radioDisabled = css`
  &::after {
    border-color: ${theme.colors.neutral30};
  }
`;

const radioActive = css`
  &::before {
    transform: scale(1);
  }

  &::after {
    border-color: ${theme.colors.neutral40};
  }
`;

const radioChecked = css`
  &::before {
    background: ${transparentize(0.7, theme.colors.primary50 as string)};
  }

  &::after {
    background: ${theme.colors.primary50};
    border-color: ${theme.colors.primary50};
  }
`;

const radioCheckedDisabled = css`
  opacity: 0.4;
`;

export const RadioStyles = {
  radio: ({ active, checked, disabled }: RadioStyleProps) =>
    cx(
      radioBase,
      disabled ? radioDisabled : '',
      !disabled && active ? radioActive : '',
      checked ? radioChecked : '',
      checked && disabled ? radioCheckedDisabled : ''
    ),
};
